import { Row, Col, Card } from "antd";
import classes from "./Dashboard.module.css";
import { Link } from "react-router-dom";
import { PlusCircleOutlined } from "@ant-design/icons";
const DataCards = (props) => {
  // // console.log(props.employeeData.analysis);

  // // console.log(employeeData.analysis);
  // console.log(employeeData.analysis);
  // console.log(employeeData.analysis);
  return (
    <Row>
      <Col lg={8} md={11} xs={24} className={classes["Col"]}>
        <Card
          style={{
            backgroundColor: "#daebf336", // Light sky blue with opacity
          }}
          bordered={true}
          className={classes["Card"]}
        >
          <Row>
            <Col
              span={24}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Link
                to="/purchase/transaction/purchase-requisition-create?indent"
                style={{ textDecoration: "none" }}
              >
                <PlusCircleOutlined
                  style={{
                    fontSize: "24px",
                    color: "#45b6fe",
                    marginRight: "8px",
                  }}
                />
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  Add Indent
                </span>
              </Link>
            </Col>
          </Row>
          <Row>
            {" "}
            {/* Add gutter for spacing between rows */}
            <Row style={{ width: "100%" }}>
              {" "}
              {/* Ensure full width */}
              <Col
                lg={18}
                md={16}
                xs={14}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "16px",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  Month To Date Indent
                </span>
              </Col>
              <Col
                lg={6}
                md={8}
                xs={10}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  className={classes["Rata1"]}
                  style={{ textAlign: "right" }}
                >
                  {props.data.TotalIndentMonthlyValue !== null
                    ? props.data.TotalIndentMonthlyValue
                    : null}
                </div>
              </Col>
            </Row>
            <Row style={{ width: "100%" }}>
              <Col
                md={24}
                xs={24} // Ensures each section goes full width on smaller screens
                className={classes["RataCol"]}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontWeight: "900",
                }}
              >
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "17px",
                    fontWeight: 600,
                  }}
                >
                  Year To Date Indent
                </span>

                <div className={classes["Rata1"]} style={{ padding: "2px" }}>
                  {props.data.TotalIndentYearlyValue !== null
                    ? props.data.TotalIndentYearlyValue
                    : null}
                </div>
              </Col>
            </Row>
            <Col
              md={24}
              xs={24}
              className={classes["RataCol"]}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontWeight: "900",
              }}
            >
              <span
                style={{ color: "#45b6fe", fontSize: "17px", fontWeight: 600 }}
              >
                Current Pending Indent
              </span>
              <div className={classes["Rata1"]} style={{ padding: "2px" }}>
                {props.data.TotalPendingIndentValue !== null
                  ? props.data.TotalPendingIndentValue
                  : null}
              </div>
            </Col>
          </Row>
        </Card>
      </Col>

      <Col lg={8} md={11} xs={24} className={classes["Col"]}>
        <Card
          style={{
            background: "#daebf336",
          }}
          bordered={false}
          className={classes["Card"]}
        >
          <Row>
            <Col
              span={24}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Link
                to="/purchase/transaction/purchase-order-create?porder"
                style={{ textDecoration: "none" }}
              >
                <PlusCircleOutlined
                  style={{
                    fontSize: "24px",
                    color: "#45b6fe",
                    marginRight: "8px",
                  }}
                />
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  Add Order
                </span>
              </Link>
            </Col>
          </Row>
          <Row>
            <Row style={{ width: "100%" }}>
              <Col
                lg={18}
                md={16}
                xs={14}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className={classes["RataCol"]}
              >
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "17px",
                    fontWeight: 600,
                  }}
                >
                  Month To Date Po
                </span>{" "}
                {/* Heading */}
              </Col>
              <Col
                lg={6}
                md={8}
                xs={10}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  className={classes["Rata1"]}
                  style={{
                    // border: "2px solid red", // Keep the existing border style
                    padding: "2px", // Add some padding for the data box
                  }}
                >
                  {props.data.TotalMonthlyPoValue !== null
                    ? props.data.TotalMonthlyPoValue
                    : null}{" "}
                  {/* Data */}
                </div>
              </Col>
            </Row>

            <Row style={{ width: "100%" }}>
              <Col
                lg={18}
                md={16}
                xs={14}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className={classes["RataCol"]}
              >
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "17px",
                    fontWeight: 600,
                  }}
                >
                  Year To Date Po
                </span>{" "}
                {/* Heading */}
              </Col>
              <Col
                lg={6}
                md={8}
                xs={10}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div className={classes["Rata1"]}>
                  {props.data.TotalYearlyPoValue !== null
                    ? props.data.TotalYearlyPoValue
                    : null}{" "}
                  {/* Data */}
                </div>
              </Col>
            </Row>

            <Row style={{ width: "100%" }}>
              <Col
                lg={18}
                md={16}
                xs={14}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className={classes["RataCol"]}
              >
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "17px",
                    fontWeight: 600,
                  }}
                >
                  Current Pending Po For Gate Pass
                </span>{" "}
              </Col>
              {/* Heading */}
              <Col
                lg={6}
                md={8}
                xs={10}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  className={classes["Rata1"]}
                  style={{
                    // color: "white", // Keep existing white color for the text
                    padding: "2px", // Add some padding for better appearance
                  }}
                >
                  {props.data.TotalPendingPoValue !== null
                    ? props.data.TotalPendingPoValue
                    : null}{" "}
                  {/* Data */}
                </div>
              </Col>
            </Row>

            <Row style={{ width: "100%" }}>
              <Col
                lg={18}
                md={16}
                xs={14}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className={classes["RataCol"]}
              >
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "17px",
                    fontWeight: 600,
                  }}
                >
                  Current Pending Po For MRIR
                </span>{" "}
                {/* Heading */}
              </Col>
              <Col
                lg={6}
                md={8}
                xs={10}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  className={classes["Rata1"]}
                  style={{
                    // color: "white", // Keep existing white color for the text
                    padding: "2px", // Add some padding for better appearance
                  }}
                >
                  {props.data.TotalPendingPoformrirValue !== null
                    ? props.data.TotalPendingPoformrirValue
                    : null}{" "}
                  {/* Data */}
                </div>
              </Col>
            </Row>
          </Row>
        </Card>
      </Col>

      <Col
        lg={{ span: 8, offset: 0 }}
        md={11}
        xs={24}
        className={classes["Col"]}
      >
        <Card
          style={{
            backgroundColor: "#daebf336", // Very light gray with 0.9 opacity
          }}
          bordered={false}
          className={classes["Card"]}
        >
          <Row>
            <Col
              span={24}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Link
                to="/purchase/transaction/mrir-create?newmrir"
                style={{ textDecoration: "none" }}
              >
                <PlusCircleOutlined
                  style={{
                    fontSize: "24px",
                    color: "#45b6fe",
                    marginRight: "8px",
                  }}
                />
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  Add Mrir
                </span>
              </Link>
            </Col>
          </Row>
          <Row style={{ width: "100%" }}>
            <Row style={{ width: "100%" }}>
              <Col
                lg={18}
                md={16}
                xs={14}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className={classes["RataCol"]}
              >
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "17px",
                    fontWeight: 600,
                  }}
                >
                  Month To Date Inward gate
                </span>{" "}
                {/* Heading */}
              </Col>
              <Col
                lg={6}
                md={8}
                xs={10}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  className={classes["Rata1"]}
                  style={{
                    // border: "2px solid red", // Keep the existing border style
                    padding: "2px", // Add some padding for the data box
                  }}
                >
                  {props.data.TotalMonthlyGateValue !== null
                    ? props.data.TotalMonthlyGateValue
                    : null}{" "}
                  {/* Data */}
                </div>
              </Col>
            </Row>

            <Row style={{ width: "100%" }}>
              <Col
                lg={18}
                md={16}
                xs={14}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className={classes["RataCol"]}
              >
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "17px",
                    fontWeight: 600,
                  }}
                >
                  Year To Date Inward Gate
                </span>{" "}
                {/* Heading */}
              </Col>
              <Col
                lg={6}
                md={8}
                xs={10}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  className={classes["Rata1"]}
                  style={{
                    // border: "2px solid red", // Keep the existing border style
                    padding: "2px", // Add some padding for the data box
                  }}
                >
                  {props.data.TotalYearlyGatePassValue !== null
                    ? props.data.TotalYearlyGatePassValue
                    : null}{" "}
                  {/* Data */}
                </div>
              </Col>
            </Row>

            <Row style={{ width: "100%" }}>
              <Col
                lg={18}
                md={16}
                xs={14}
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className={classes["RataCol"]}
              >
                <span
                  style={{
                    color: "#45b6fe",
                    fontSize: "17px",
                    fontWeight: 600,
                  }}
                >
                  Current Pending Inward Gate
                </span>{" "}
                {/* Heading */}
              </Col>

              <Col
                lg={6}
                md={8}
                xs={10}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  className={classes["Rata1"]}
                  style={{
                    // color: "white", // Keep existing white color for the text
                    padding: "2px", // Add some padding for better appearance
                  }}
                >
                  {props.data.TotalPendingGatepassforgatepassValue !== null
                    ? props.data.TotalPendingGatepassforgatepassValue
                    : null}{" "}
                  {/* Data */}
                </div>
              </Col>
            </Row>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default DataCards;
